import styled from 'styled-components'

import { cases } from '@subaio/utils'

type Props = {
	type: 'default' | 'clear' | 'error'
}

export const Container = styled.div<Props>`
	position: absolute;
	inset: 1px 5px 1px auto;
	display: flex;
	align-items: center;

	pointer-events: none;

	color: ${({ type, theme }) =>
		cases(type, {
			default: theme.color.icon,
			clear: theme.color.inputClear,
			error: theme.color.danger,
		})};
`
